// If the user is accessing the page via 'jump' link, keep track of this initial ID - useful for overriding H1 observer behaviour
const initialId = window.location.hash;
let activeId = initialId;
let initialIdHandled = false;

// Select all headings in the article, including the H1 at the top.
const headings = document.querySelectorAll('article h1, article h2[id]');

const observer = new IntersectionObserver(entries => {
	const current = entries.find(entry => entry.isIntersecting);
	if (current) {
		const targetId = `#${current.target.id}`;
		// When we get to the initial ID, stop treating it any differently
		if (!initialIdHandled && initialId && targetId === initialId) {
			initialIdHandled = true;
		}

		// Update the activeId only if it's changed - and if the initial ID's been dealt with already
		if (targetId !== activeId && (!initialId || initialIdHandled)) {
			activeId = targetId;
			// Remove the ID from the address bar if we're at the top of the page
			if (current.target.tagName === 'H1') {
				window.history.replaceState(null, null, ' ');
			}
			// Otherwise put the ID in the address bar
			else {
				window.history.replaceState(null, null, targetId);
			}
		}
	}
}, {
	threshold: 0.5,
	rootMargin: '-5% 0px -60% 0px',
});

headings.forEach(heading => {
	observer.observe(heading);
});
